/**
 * <RevisionProgramPage> — the "/study-program" full screen rebuilt on the DS (page, L0.1).
 *
 * Mirrors the legacy `StudyProgramScreen`: a full-screen page (no bottom tab) with a `<Header>`
 * ("Programme de révision" + back) over day-grouped items via `<RevisionProgramList>`.
 * Pure UI: data in as `UIRevisionProgramGroup[]`, events out as callbacks — no Redux, no navigation,
 * renderable in Storybook. Parent legacy day items are not clickable — cards render without `onPress`.
 *
 * Aucun état de chargement : l'écran lit un cache (`revisionProgramViewModel`), jamais le réseau.
 * La page n'offre donc pas de `loading` — elle retombait sur la roue du gabarit le jour où quelqu'un
 * l'aurait passé. Le jour où elle lira le réseau, elle aura son squelette.
 */
import { IconButton } from "../../atoms/Buttons/IconButton"
import { Text } from "../../atoms/typography/Text"
import { Header } from "../../molecules/Header"
import { PageTemplate } from "../../templates/PageTemplate"
import { RevisionProgramList } from "../../templates/RevisionProgramList"
import { type UIRevisionProgramGroup } from "../../../ports/primary/ui/types"

export type RevisionProgramPageProps = {
    groups: UIRevisionProgramGroup[]
    onClose?: () => void
    error?: unknown
    onRetry?: () => void
}

export function RevisionProgramPage(props: RevisionProgramPageProps) {
    const { groups, onClose, error, onRetry } = props

    const header = (
        <Header
            title="Programme de révision"
            left={<IconButton iconName="chevron-left" appearance="transparent" iconColor="primary" onPress={onClose} />}
        />
    )

    return (
        <PageTemplate header={header} error={error} onRetry={onRetry}>
            {groups.length === 0 ? (
                <Text color="text-muted">Aucun programme de révision trouvé</Text>
            ) : (
                <RevisionProgramList groups={groups} />
            )}
        </PageTemplate>
    )
}
